// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AuthBinding$PorterinFeature from "../../../core/helpers/AuthBinding.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../containers/login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as KeywordHelper$PorterinFeature from "../../../../containers/keyword/domain/helpers/KeywordHelper.mjs";
import * as LeadFlowBindings$PorterinFeature from "../../../../containers/bindings/LeadFlowBindings.mjs";
import * as ChangeCategoryCmp$PorterinFeature from "./ChangeCategoryCmp.mjs";
import * as FareEstimateFormsModuleScss from "../styles/FareEstimateForms.module.scss";

var styles = FareEstimateFormsModuleScss;

function SpotFareEstimateWrapperCmp(Props) {
  var onChangeCategory = Props.onChangeCategory;
  var category_name = Props.category_name;
  var change_label = Props.change_label;
  var is_mobileOpt = Props.is_mobile;
  var serviceCategoryType = Props.serviceCategoryType;
  var is_mobile = is_mobileOpt !== undefined ? is_mobileOpt : false;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var authBinding = AuthBinding$PorterinFeature.convertAuthContext(AuthContextV1$PorterinFeature.useAuthContext(undefined));
  return React.createElement("div", {
              className: styles["component-wrapper"]
            }, React.createElement(ChangeCategoryCmp$PorterinFeature.make, {
                  onChangeCategory: onChangeCategory,
                  className: styles["change-category"],
                  currentCategory: KeywordHelper$PorterinFeature.serviceCategoryToGAString(serviceCategoryType),
                  category_name: category_name,
                  change_label: change_label
                }), is_mobile ? React.createElement(LeadFlowBindings$PorterinFeature.FareEstimateMobileForm.make, {
                    category: KeywordHelper$PorterinFeature.serviceCategoryToString(serviceCategoryType),
                    city_context: citySelectedContext,
                    auth_data: authBinding,
                    on_lead_success_handler: (function (param) {
                        
                      })
                  }) : React.createElement(LeadFlowBindings$PorterinFeature.FareEstimateForm.make, {
                    category: KeywordHelper$PorterinFeature.serviceCategoryToString(serviceCategoryType),
                    city_context: citySelectedContext,
                    auth_data: authBinding,
                    on_lead_success_handler: (function (param) {
                        
                      })
                  }));
}

var make = SpotFareEstimateWrapperCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
